module.exports = __webpack_public_path__ + "static/media/lease_icon.8fd071b3.svg";